import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import './PromoCode.scss';
import loader from '../../../assets/loading.gif';

class PromoCode extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      promoCode: this.props.promotionCode ? this.props.promotionCode : '',
      loading: false,
      validated: this.props.validatedPromoCode,
      consumed: false,
      applied: this.props.promotionCode && !this.props.validatedPromoCode
    };

    this.handleChange = this.handleChange.bind(this);
    this.validateCode = this.validateCode.bind(this);
  }

  handleChange(e) {
    this.setState({ promoCode: e.target.value });
  }

  async validateCode(e) {
    e.preventDefault();
    this.setState({ loading: true, validated: false, consumed: false, applied: false });
    const code = this.state.promoCode;
    const validateResponse = await this.props.validatePromoCode(code);
    if (validateResponse.code && validateResponse.consumed) {
      this.setState({ loading: false, consumed: true });
      return;
    }
    if (validateResponse.code && !validateResponse.consumed) {
      this.setState({ loading: false, validated: true, applied: true });
      return;
    }
    this.setState({ loading: false, applied: true });
  }

  render() {
    const disablePromoSubmit = this.state.loading || this.state.validated || this.state.promoCode === '';
    return (
      <div className="promo-container">
        <form name="promoCodeForm" onSubmit={e => this.validateCode(e)}>
          <label className="promo-label" htmlFor="promoCode">Got a promo code?</label>
          <div className="input-group">
            <input
              type="text"
              className="input form-control"
              name="promoCode"
              placeholder="Enter code"
              value={this.state.promoCode}
              maxLength="15"
              disabled={this.state.validated}
              onChange={this.handleChange}
            />
            <span className="input-group-btn">
              <Button
                className="btn btn-default"
                type="button"
                name="promoCodeButton"
                disabled={disablePromoSubmit}
                onClick={e => this.validateCode(e)}
              >
                { this.state.loading ?
                  <img
                    src={loader}
                    height="20"
                    alt="Loading..."
                    role="presentation"
                  />
                :
                  <div>
                    <i className="skinny-fa" aria-hidden="true" />
                    <span className="sr-only">Validate</span>
                  </div>
                }
              </Button>
            </span>
          </div>
          { this.state.consumed &&
            <p className="promo-response promo-error">Sorry, that code has already expired or is not valid.</p>
          }
          { this.state.validated &&
            <p className="promo-response promo-success">
              Yay! No connection fee for you!<br />
              We&#39;ll get back to you ASAP with the rest of the details.
            </p>
          }
          { (!this.state.validated && this.state.applied) &&
            <p className="promo-response">
              Thanks for entering a promo code.<br />
              We will check this matches ours, and get back to you ASAP.
            </p>
          }
        </form>
      </div>
    );
  }
}

PromoCode.propTypes = {
  validatePromoCode: PropTypes.func,
  promotionCode: PropTypes.string,
  validatedPromoCode: PropTypes.bool
};

export default PromoCode;



/** WEBPACK FOOTER **
 ** ./src/components/payment/PromoCode/PromoCode.js
 **/